import { z } from "zod";
import { SocialPostType } from "../../types/models/campaign.models.types";
import {
  SocialCreatorType,
  SocialPlatforms,
} from "../../types/models/social.models.types";

function transformEmptyString(x: string) {
  return x.trim().length === 0 ? null : x;
}

export const zCreateCampaignFormBrand = z.object({
  name: z.string().min(1, "Name is required"),
  coverImage: z
    .object({
      id: z.string(),
      name: z.string(),
      url: z.string(),
    })
    .nullable()
    .default(null),
  coverImageFile: z
    .array(
      z.object({
        file: z.instanceof(File),
      })
    )
    .default([]),
  socialPlatform: z.nativeEnum(SocialPlatforms).nullable().default(null),
  socialPostType: z.nativeEnum(SocialPostType).nullable().default(null),
  socialCreatorType: z.nativeEnum(SocialCreatorType).nullable().default(null),
  aboutCampaign: z
    .string()
    .transform(transformEmptyString)
    .nullable()
    .default(null),
  aboutBrand: z
    .string()
    .transform(transformEmptyString)
    .nullable()
    .default(null),
  hashtags: z.string().transform(transformEmptyString).nullable().default(null),
  mentions: z.string().transform(transformEmptyString).nullable().default(null),
  do: z.string().transform(transformEmptyString).nullable().default(null),
  dont: z.string().transform(transformEmptyString).nullable().default(null),
});

export type IzCreateCampaignFormBrand = z.infer<
  typeof zCreateCampaignFormBrand
>;
